import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase/app'
require ('firebase/storage')
require ('firebase/database')
require ('firebase/firestore')
import { GetParamString } from '../main';
import { stat } from 'fs'

const firebaseConfig = {
  apiKey: "AIzaSyClsRQNkuU1RJ5VSSP4FuoC5uIIpMsv3KM",
  authDomain: "massive-acrobat-248605.firebaseapp.com",
  databaseURL: "https://massive-acrobat-248605.firebaseio.com",
  projectId: "massive-acrobat-248605",
  storageBucket: "massive-acrobat-248605.appspot.com",
  messagingSenderId: "329248849984",
  appId: "1:329248849984:web:7868ad46c3bbfc10"
};

firebase.initializeApp(firebaseConfig)
const db = firebase.firestore()
export default db

Vue.use(Vuex)



/**
 * delay or pause for some time
 * @param {number} t - time (ms)
 * @return {Promise<*>}
 */
const delay = async t => new Promise(resolve => setTimeout(resolve, t));

export const BluetoothCom =
{
    state:{
        deviceName:"",
        deviceSerial:"",
        'connected':false,
        connectedDevice:{}, //Rodykle i device struktura
        reqId:0,
        toSend:false
    },
    mutations:{
        setConnection(state, OnOff) {
            state.connected = OnOff
            if(!OnOff) state.connectedDevice = null
          },
        setConnectedDevice(state, Device) {
            state.connectedDevice = Device
        },
        setReqId(state,myNumber)
        {
          state.reqId = myNumber
        },
        setSendStatus(state,onOff)
        {
          state.toSend = onOff
        },
        setDeviceName(state,Name){
          state.deviceName = Name
        },
        setDeviceSerial(state, Serial){
          state.deviceSerial = Serial
        },
    },
    getters:{
        getConnection(state)    {
            return state.connected
          },
        getConnectedDevice(state) {
            if (state.connected) return state.connectedDevice
            else return ''
        },
        isSupported(state){
          return navigator.bluetooth
        },
        getSendStatus(state){
          return state.toSend
        },
        getReqId(state){
          return state.reqId
        },
        getDeviceName(state){
          return state.deviceName
        },
        getDeviceSerial(state){
          return state.deviceSerial
        }
    },
    actions:{
        connectToDevice(context)
        {
            let filters = [];
          
            let filterService = '51600001-b08a-f884-e678-231e36ee5687';
          
            if (filterService) {
              filters.push({services: [filterService]});
            }
          
            let filterName = null;
            if (filterName) {
              filters.push({name: filterName});
            }
          
            let filterNamePrefix = "MHD";
            if (filterNamePrefix) {
              filters.push({namePrefix: filterNamePrefix});
            }
          
            let options = {};
          
              options.filters = filters;
            
          
            console.log('Requesting Bluetooth Device...');
            console.log('with ' + JSON.stringify(options));
            navigator.bluetooth.requestDevice(options)
            .then(device => {
                var item = {};
          
              console.log('> Name:             ' + device.name);
              item.title = device.name;
              console.log('> Id:               ' + device.id);
          
              console.log('> Connected:        ' + device.gatt.connected);
              //items.push(item);
              device.addEventListener('gattserverdisconnected', onDisconnected);

              return device.gatt.connect();
            })
            .then(async server => {

              const service = await server.getPrimaryService('51600001-b08a-f884-e678-231e36ee5687');
              console.log('Getting Characteristic...');
              const characteristic = await service.getCharacteristic('51600006-b08a-f884-e678-231e36ee5687');
              var Value = await characteristic.readValue();
              var newValue = GetParamString(Value,0,6,"utf-8")
              context.commit('setDeviceName', newValue)


              console.log('Succesfully connected');
              context.commit('setConnection', true)
              context.commit('setConnectedDevice', server)
            })
            .catch(error => {
              console.log('Argh! ' + error);
              context.commit('showMessage', {text: error, type: 'error'})
            });
        },
        async getPageParamsValue(context,uuids)
        {
          try
          {
            let server = context.state.connectedDevice;
            if(server)
            {
              const service = await server.getPrimaryService('51600001-b08a-f884-e678-231e36ee5687');
              console.log('Getting Characteristic...');
              const characteristic = await service.getCharacteristic(uuids.cuuid);
              return await characteristic.readValue();
            }
          }
          catch(error)
          {
            console.log('Argh! ' + error);
          }
        },
        async UpgradeFirmware(context,data)
        {

          // Get a reference to the storage service, which is used to create references in your storage bucket
            var storage = firebase.storage();

            // Create a storage reference from our storage service
            var storageRef = storage.ref();

            // Create a child reference
            var firmwareRef = storageRef.child(data.path);

            firmwareRef.getDownloadURL().then(async function(url) {
              // `url` is the download URL for 'images/stars.jpg'
            
              // This can be downloaded directly:
              var xhr = new XMLHttpRequest();
              xhr.responseType = 'blob';
              xhr.onload =async  function(event) {
                var firmwareBlob = xhr.response;

                if (firmwareBlob)
                {
                  
                  var firmware = new DataView(await firmwareBlob.arrayBuffer())
                  var endian = true;
                  var magicSign = firmware.getUint32(0,endian)
                  var headerLength = firmware.getUint32(4,endian)
                  var totalDirectories = firmware.getUint16(8,endian)
                  var totalFiles = firmware.getUint16(10,endian)
                  var version = firmware.getUint32(12,endian)
                  var decimal = firmware.getUint16(16,endian)
                  var tryCnt = 0 

                  if (!((decimal === 1057)&&(magicSign === 0x41524554)))
                  {
                    context.commit('showMessage', {text: "Wrong firmware File", type: 'error'})
                  }

                  context.commit('showProgressBar',{text:"Updating Firmware..."})
                  
                  
                  var charBytes = new DataView(await new ArrayBuffer(12))
                  var offset = 0
                  var myFiles = [];
                  var TotalFilesLength = 0
                  var Address = 0 
                  var lengthLeft = 0
                  var length = 0
                  var crc_data = 0xFFFF
                  var TotalSentLength = 0

                  for (let index = 0; index < totalFiles; index++) {

                    offset = 48 + 136 * totalDirectories + 64 * index + 4

                    let decoder = new TextDecoder('utf-8')
                    var myBuffer = firmware.buffer.slice(offset, offset+length)                  
                   
                    var myFile = {};
                    myFile.fileName = decoder.decode(myBuffer,{stream:true}).replace(/\0.*$/g,'').trim()
                    offset += 32
                    myFile.LZMAFileLength = firmware.getUint32(offset,endian)
                    offset += 4
                    myFile.origFileLength = firmware.getUint32(offset,endian)
                    offset += 16
                    myFile.fileNo =  firmware.getUint32(offset,endian)
                    offset += 6

                    TotalFilesLength += myFile.origFileLength

                    if (index == 0)
                      myFile.fileStartAddress = 48 + 136 * totalDirectories + 64 * totalFiles + 4;
                    else
                      myFile.fileStartAddress = 48 + 136 * totalDirectories + 64 * totalFiles + 4 + myFiles[index - 1].origFileLength;

                    myFile.crc = firmware.getUint16(offset,endian)
                    myFiles.push(myFile)  
                  }
      
                  try
                  {
                   let server = context.state.connectedDevice;
                   if(server)
                   {
                    for (let index = 0; index < myFiles.length; index++) {
                      const currentFile = myFiles[index];
                      charBytes = new DataView(await new ArrayBuffer(12))
                      const cmdService = await server.getPrimaryService('51600001-b08a-f884-e678-231e36ee5687')
                      console.log('preparing for uploading')
                      const cmdCharacteristic = await cmdService.getCharacteristic('51600007-b08a-f884-e678-231e36ee5687')
                      cmdCharacteristic.writeValue(charBytes)

                      // await delay(300)

                      const dataService = await server.getPrimaryService('51600001-b08a-f884-e678-231e36ee5687')
                      const dataCharacteristic = await dataService.getCharacteristic('51600008-b08a-f884-e678-231e36ee5687')

                      // await delay(300)

                      const statusService = await server.getPrimaryService('51600001-b08a-f884-e678-231e36ee5687')
                      console.log('Subscribing for status');
                      const statusCharacteristic = await statusService.getCharacteristic('51600009-b08a-f884-e678-231e36ee5687');

                      // await delay(300)

                      statusCharacteristic.startNotifications().then(_=>{
                          console.log('> Notifications started');
                          statusCharacteristic.addEventListener('characteristicvaluechanged', onProgramingNotification);
                      })  
                      .catch(error => {
                        console.log('Argh! ' + error);
                        context.commit('closeProgressBar')
                        return
                      });
                      await delay(1500)
                      Address = currentFile.fileStartAddress;

                      for (let A = 0; A < currentFile.origFileLength; A+=256) {
                        context.commit('updateProgress',((A+TotalSentLength)/TotalFilesLength))
                        lengthLeft = currentFile.origFileLength - A
                        tryCnt = 0

                        if (lengthLeft >= 256)length = 256
                        else length = lengthLeft

                        charBytes.setUint8(0,0x81)
                        charBytes.setUint8(1,currentFile.fileNo)
                        charBytes.setUint16(2,length,endian)
                        charBytes.setUint32(4,Address-currentFile.fileStartAddress,endian)
                        crc_data = 0xFFFF
                        for(let ix=0 ; ix<8; ix++ )
                        {
                          crc_data = calc_crc(crc_data,charBytes.getUint8(ix))
                        }
                        for(let ix=0 ; ix<length; ix++ )
                        {
                          crc_data = calc_crc(crc_data,firmware.getUint8(Address+ix))
                        }
                        charBytes.setUint16(8,crc_data,endian)
                        context.state.reqId = Math.floor(Math.random() * 100) + 1;
                        charBytes.setUint16(10,context.state.reqId,endian)
                        var charData  = await new DataView(await firmware.buffer.slice(Address,Address+length))
                        try
                        {
                          console.log('Requesting send status of ReqId: ' + context.state.reqId + 'file length sent: ' + A + ' Address: ' + Address);

                          context.state.toSend = false
                          var timeOut = 0

                          await dataCharacteristic.writeValue(charData)
                          await cmdCharacteristic.writeValue(charBytes)

                          while (!context.state.toSend)
                          {
                              await delay(1)
                              timeOut++
                              if (timeOut > 1000)
                                  break
                          }

                          if (timeOut > 1000)
                          {
                            context.commit('showMessage', {text: 'Failed in the middle of File', type: 'error'})
                            console.log('Argh! ' + 'Failed in the middle of File');
                            context.commit('closeProgressBar')
                            return
                          }

                        }
                        catch(error)
                        {
                          context.commit('showMessage', {text: error, type: 'error'})
                          console.log('Argh! ' + error);
                          context.commit('closeProgressBar')
                          return
                        }

                        Address+=length
                      }

                      try
                      {
                        charBytes.setUint8(0,0x84)
                        charBytes.setUint8(1,currentFile.fileNo)
                        charBytes.setUint16(2,6,endian)
                        charBytes.setUint32(4,0,endian)

                        crc_data = 0xFFFF
                        for(let ix=0 ; ix<8; ix++ )
                        {
                          crc_data = calc_crc(crc_data,charBytes.getUint8(ix))
                        }
                        var myCrc_data = 0xFFFF
                        for(let ix=0 ; ix<currentFile.origFileLength; ix++ )
                        {
                          myCrc_data = calc_crc(myCrc_data,firmware.getUint8(currentFile.fileStartAddress+ix))
                        }

                        charData.setUint32(0,currentFile.origFileLength,endian)
                        charData.setUint16(4,myCrc_data,endian)

                        for(let ix=0 ; ix<6; ix++ )
                        {
                          crc_data = calc_crc(crc_data,charData.getUint8(ix))
                        }
                        charBytes.setUint16(8,crc_data,endian)
                        context.state.reqId = Math.floor(Math.random() * 100) + 1;
                        charBytes.setUint16(10,context.state.reqId,endian)
                        console.log('Requesting send status of ReqId: ' + context.state.reqId + ' Address: ' + Address);
                        context.state.toSend = false
                        timeOut = 0

                        await dataCharacteristic.writeValue(charData)
                        await cmdCharacteristic.writeValue(charBytes)

                        while (!context.state.toSend)
                        {
                            await delay(1)
                            timeOut++
                            if (timeOut > 1000)
                                break
                        }
                        if (timeOut > 1000)
                        {
                          context.commit('showMessage', {text: 'Failed to finish File upload', type: 'error'})
                          console.log('Argh! ' + 'Failed to finish File upload');
                          context.commit('closeProgressBar')
                          return
                        }

                      }
                      catch(error)
                      {
                        context.commit('showMessage', {text: error, type: 'error'})
                        console.log('Argh! ' + error);
                        context.commit('closeProgressBar')
                        return
                      }

                      if(index === myFiles.length-1)
                      {
                        charBytes.setUint8(0,0x88)
                        crc_data = 0xFFFF
                        for(let ix=0 ; ix<8; ix++ )
                        {
                          crc_data = calc_crc(crc_data,charBytes.getUint8(ix))
                        }
                        charBytes.setUint16(8,crc_data,endian)

                        // statusCharacteristic.stopNotifications().then(_=>{statusCharacteristic.removeEventListener('characteristicvaluechanged',onProgramingNotification)})

                        cmdCharacteristic.writeValue(charBytes)
                        //context.dispatch("disconnectFromDevice")
                        // await delay(300)
                        

                        context.commit('showMessage', {text: "Software successfully updated, please wait for device to restart", type: 'success'})
                        console.log('Software successfully updated');
                      }
                      TotalSentLength = Address;
                     }



                   }
                   context.commit('closeProgressBar')
                 }
                 catch(error)
                 {
                   context.commit('showMessage', {text: error, type: 'error'})
                   console.log('Argh! ' + error);
                   context.commit('closeProgressBar')
                   return
                 }

                }
              };
              xhr.open('GET', url);
              xhr.send();
            
            }).catch(function(error) {
                // A full list of error codes is available at
                // https://firebase.google.com/docs/storage/web/handle-errors
                switch (error.code) {
                  case 'storage/object-not-found':
                    // File doesn't exist
                    break

                  case 'storage/unauthorized':
                    // User doesn't have permission to access the object
                    break

                  case 'storage/canceled':
                    // User canceled the upload
                    break
                  case 'storage/unknown':
                    // Unknown error occurred, inspect the server response
                    break
                }
            });

        },
        async WriteGroupParamsValue(context,group)
        {
         if(group)
         {
           var NewBuff = {}
           NewBuff  = group.cvalue
           group.params.forEach(function(param) {
             if((param.type === 0)||(param.type === 2)||(param.type === 3))
             {
              switch(param.length){
                case 1:
                    return NewBuff.setUint8(param.offset,param.value);
                case 2:
                    return NewBuff.setUint16(param.offset,param.value);
                case 4:
                    return NewBuff.setUint32(param.offset,param.value);      
              }
             }
             else if(param.type === 4)
             {
              var buffer = new Uint8Array(param.length);
              if(param.encoding === "utf-8")
              {
                var enc = new TextEncoder(); // always utf-8
                var stringbuffer = enc.encodeInto(param.value,buffer)
              }
              else {
                var stringbuffer = Buffer.from(param.value,'utf16le')
                stringbuffer.forEach (function(val,Index)
                {
                  buffer[Index]=val
                })
              }

              buffer.forEach (function(val,Index)
              {
                NewBuff.setUint8(param.offset+Index,val);
              })
             }             

           });
           try
           {
            let server = context.state.connectedDevice;
            if(server)
            {
              const service = await server.getPrimaryService('51600001-b08a-f884-e678-231e36ee5687');
              console.log('Writting Characteristic...');
              const characteristic = await service.getCharacteristic(group.cuuid);
              characteristic.writeValue(NewBuff);
            }
          }
          catch(error)
          {
            context.commit('showMessage', {text: error, type: 'error'})
            console.log('Argh! ' + error);
            return
          }
          context.commit('showMessage', {text: "Parameters successfully updated", type: 'success'})
         }
        },
        async WriteCharValue(context,data)
        {
          try
          {
           let server = context.state.connectedDevice;
           if(server)
           {
             const service = await server.getPrimaryService('51600001-b08a-f884-e678-231e36ee5687');
             console.log('Writting Characteristic...');
             const characteristic = await service.getCharacteristic(data.cuuid);
             characteristic.writeValue(data.value);
           }
         }
         catch(error)
         {
           context.commit('showMessage', {text: error, type: 'error'})
           console.log('Argh! ' + error);
           return
         }
         context.commit('showMessage', {text: data.message, type: 'success'})
        },
        async disconnectFromDevice(context) {
          if (context.state.connectedDevice) {    
            console.log('Disconnecting from Bluetooth Device...');
          if (context.state.connectedDevice.device.gatt.connected) {            
            await context.state.connectedDevice.device.gatt.disconnect();
            BluetoothCom.mutations.setConnection(BluetoothCom.state,false);
          } else {
            console.log('> Bluetooth Device is already disconnected');
          }
        }
        }  
    },
    modules: {
      //msg: moduleMsg,
      // lang: moduleLang,
      // modal: moduleModal,
    }
  
}
export const  onDisconnected = function() {
  // Object event.target is Bluetooth Device getting disconnected.
  console.log('> Bluetooth Device disconnected');
  //context.commit('showMessage', {text: "Disconnected from device", type: 'error'})
  //if(BluetoothCom.state.connectedDevice)
    //BluetoothCom.modules.msg.mutations.showMessage(BluetoothCom.modules.msg.state,{text: "Disconnected from device", type: 'error'})
  BluetoothCom.mutations.setConnection(BluetoothCom.state,false);
}

export const onProgramingNotification = function(){
  
  if(BluetoothCom.state.connectedDevice)
  {
    let value = event.target.value;
    var tmpId = value.getUint16(2,true)
    var status = value.getUint8(0,true)
    if((status===0)&&(tmpId===BluetoothCom.getters.getReqId(BluetoothCom.state)))
      BluetoothCom.mutations.setSendStatus(BluetoothCom.state,true)
    console.log('> Updating ...  Status:' + status + ' ReqId: ' + tmpId);
  } 
}

/** crc_data: pradiniai CRC duomenys (pvz., 0xFFFF), data - eilinis baitas CRC skaiciavimui */
export const calc_crc = function(crc_data, data) {
  var ix = 0;
  var lsb = 0;
  var crc_temp = crc_data;
  crc_temp = ((crc_temp ^ data) | 0xFF00) & (crc_temp | 0x00FF);
  for (ix = 0; ix < 8; ix++) {
    lsb = (crc_temp & 0x0001);
    crc_temp >>= 1;
    if (lsb) crc_temp ^= 0xA001;
  }
  return crc_temp;
}